<template>
  <div>
    <h5 class="pnr-type-checkbox">
      <a-radio-group
        :name="'productCheckbox' + '_' + index"
        @change="onChangeProductCheckbox($event, index)"
        :options="productList(item)"
        v-model="item.productCheckedList"
      >
      </a-radio-group>
    </h5>
    <a-table
      class="product-table"
      :ref="'productTable_' + index"
      :columns="columns3"
      :dataSource="faresData(item, index)"
      :rowKey="record => record.keyid"
      :pagination="false"
      :row-selection="rowSelection(index)"
    ></a-table>
  </div>
</template>
<script>
import _ from 'lodash'
let changePrice = 0
const columns3 = [
  {
    title: '航段',
    dataIndex: 'airline',
    align: 'center'
  },
  {
    title: '乘客类型',
    dataIndex: 'passengerTypeText',
    align: 'center'
  },
  {
    title: '人数',
    dataIndex: 'passengerCount',
    align: 'center'
  },
  {
    title: '产品',
    dataIndex: 'productName',
    align: 'center'
  },
  {
    title: '票面价',
    dataIndex: 'channleFare',
    align: 'center'
  },
  {
    title: '实售价',
    dataIndex: 'marketFare',
    align: 'center'
  },
  {
    title: '民航发展基金',
    dataIndex: 'airportTax',
    align: 'center'
  },
  {
    title: '燃油税',
    dataIndex: 'fuelTax',
    align: 'center'
  },
  {
    title: '代理费',
    dataIndex: 'agentFee',
    align: 'center'
  },
  {
    title: '促销费',
    dataIndex: 'spFee',
    align: 'center'
  }
  // {
  //   title: '短信服务费',
  //   dataIndex: 'smsFee',
  //   align: 'center'
  // }
]
export default {
  props: {
    pnrData: Object,
    item: Object,
    index: Number,
    defaultPrice: Number
  },
  data () {
    return {
      columns3,
      selectedRowKeys: []
    }
  },
  computed: {
    faresData () {
      return (item, parentIndex) => {
        let faresData = []
        let row = item
        // row.index = index + 1
        let airline = item.segment.depCode + '-' + item.segment.arrCode
        let fares = row.fares
        fares.forEach((fare, index) => {
          let innerRow = fare
          innerRow.airline = airline
          let psgType = ''
          switch (fare.passengerType) {
            case 'ADULT':
              psgType = '成人'
              break
            case 'CHILD':
              psgType = '儿童'
              break
            case 'INFANT':
              psgType = '婴儿'
              break
          }
          innerRow.keyid =
            (innerRow.bigProductCode
              ? innerRow.bigProductCode
              : innerRow.passengerType) +
            '_' +
            parentIndex +
            '_' +
            index
          innerRow.passengerTypeText = psgType
          innerRow.isShow =
            (item.productCheckedList &&
              item.productCheckedList.includes(innerRow.bigProductCode)) ||
            fare.passengerType === 'INFANT'
          faresData.push(innerRow)
        })
        faresData = faresData.filter(item => {
          return item.isShow === true
        })
        faresData = _.orderBy(
          faresData,
          ['bigProductCode', 'marketFare'],
          ['desc', 'asc']
        )
        return faresData
      }
    },
    rowSelection () {
      const self = this
      const { pnrData } = this
      return index => {
        return {
          selectedRowKeys: self.selectedRowKeys,
          onChange: (selectedRowKeys, selectedRows) => {
            // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
            self.selectedRowKeys = Array.from(new Set(selectedRowKeys))
            const [selectedRow, selectedRowKey] = [
              selectedRows[0],
              selectedRowKeys[0]
            ]
            pnrData.totalFare = changePrice = 0
            pnrData.segmentFares.forEach((item, index2) => {
              if (index2 === index) {
                item.selfPrice =
                  selectedRow.passengerCount *
                  (Number(selectedRow.marketFare) +
                    Number(selectedRow.airportTax) +
                    Number(selectedRow.fuelTax) -
                    Number(selectedRow.agentFee) -
                    Number(selectedRow.spFee))
                item.fares.forEach(item2 => {
                  if (item2.keyid === selectedRowKey) {
                    self.$set(item2, 'checked', true)
                  } else {
                    self.$set(item2, 'checked', false)
                  }
                })
              }
              if (item.selfPrice) {
                changePrice += item.selfPrice
              }
            })
            pnrData.totalFare = self.$parent.defaultPrice + changePrice
            self.$forceUpdate()
          },
          getCheckboxProps: record => ({
            props: {
              disabled: record.passengerType === 'INFANT', // Column configuration not to be checked
              name: record.name
            }
          }),
          type: 'radio'
        }
      }
    },
    productList () {
      return params => {
        const list = _.uniqBy(params.products, 'prodtuctName')
        list.forEach(item => {
          item.label = item.prodtuctName
          item.value = item.productCode
        })
        return list
      }
    }
  },
  methods: {
    onChangeProductCheckbox (event, parentIndex) {
      // console.log(this.$refs['productTable_' + parentIndex])
      this.rowSelection(parentIndex).onChange([[]], [[]])
      this.$forceUpdate()
    }
  },
  created () {
    const { pnrData } = this
    pnrData.segmentFares.forEach(item => {
      item.productCheckedList = []
    })
  }
}
</script>

<style scoped></style>
